import {
  useAuthenticationContext,
  useGetUserRoles,
} from '@festina-life/authentication'

import { useHook } from '../../lenteHooks'
import { type AnnotationProps, useAnnotations } from './useAnnotations'
import { isAllowedToViewEntity } from './utils'

export const useIsAllowedToViewEntity = (props: AnnotationProps) => {
  const { data: userRoles } = useGetUserRoles()
  const { shouldValidateAuthenticationHooks } = useAuthenticationContext()

  const isEnabled = props.enabled === undefined ? true : props.enabled

  const annotations = useAnnotations(props)

  const tenantId = useHook('routing.tenant.useTenantParam')({
    isOptional: true,
  })

  return (
    !shouldValidateAuthenticationHooks ||
    !isEnabled ||
    isAllowedToViewEntity({ annotations, tenantId, userRoles })
  )
}
